import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Fab, Box, Badge } from "@material-ui/core";
import { LocalMall, Close, Euro } from "@material-ui/icons";

const useShopBasketFABStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(4),
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));

const useBadge = makeStyles((theme) => ({
  root: {},
  badge: {
    fontSize: theme.typography.pxToRem(25),
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: theme.palette.primary.light,
  },
}));

const useMiddleLeftFABStyles = makeStyles((theme) => ({
  root: {
    // marginTop: theme.spacing(3),
    // marginBottom: "auto",
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));
const useMiddleRightFABStyles = makeStyles((theme) => ({
  root: {
    // position: "fixed",
    // bottom: theme.spacing(20),
    // right: theme.spacing(2),
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));

export const LocalMallFAB = (props) => {
  const classes = useShopBasketFABStyles();
  const classesBadge = useBadge();
  return (
    <Box className={classes.root}>
      <Badge
        classes={{ badge: classesBadge.badge, root: classesBadge.root }}
        badgeContent={props.badgeContent}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Fab variant="extended" color="secondary" onClick={props.onClick}>
          <LocalMall className={classes.extendedIcon} />
          Warenkorb
        </Fab>
      </Badge>
    </Box>
  );
};

export const CloseFAB = (props) => {
  const classes = useMiddleLeftFABStyles();
  return (
    <Box className={classes.root}>
      <Fab variant="extended">
        <Close className={classes.extendedIcon} />
        Schliessen
      </Fab>
    </Box>
  );
};

export const CheckFAB = (props) => {
  const classes = useMiddleRightFABStyles();
  return (
    <Box className={classes.root}>
      <Fab variant="extended" color="secondary">
        <Euro className={classes.extendedIcon} />
        Bestellen
      </Fab>
    </Box>
  );
};
